// extracted by mini-css-extract-plugin
export default {"wrapper":"DetailsGrid_wrapper__PYBaL"};